import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars-2";
 
const Sidebar = () => {
  const [selectedItems, setSelectedItems] = useState(Array().fill(false));
  const { pathname } = useLocation();
 
 
 
  const handleItemClick = (index) => {
    setSelectedItems((prevSelectedItems) => {
      const updatedSelectedItems = [...prevSelectedItems];
      console.log("selectedItems", selectedItems);
 
 
      // Toggle the state of the clicked item
      updatedSelectedItems[index] = !updatedSelectedItems[index];
 
      return updatedSelectedItems;
    });
  };
 
  // const handleSubdropClick = (index) => {
  //   setSelectedItems((prevSelectedItems) => {
  //     const updatedSelectedItems = [...prevSelectedItems];
  //     updatedSelectedItems[index] = !updatedSelectedItems[index];
  //     return updatedSelectedItems;
  //   });
  // };
 
 
 
  return (
    <>
      <div className="sidebar" id="sidebar">
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul className="sidebar-vertical">
                {/* Menu */}
                <li className="menu-title">
                  <p><span>Menu</span></p>
                </li>
                <li className="submenu">
               
 
                  <li>
  <Link className={pathname === "/index" ? "active" : ""} to="/index">
    <i className="fe fe-home" />
    <span>Dashboard</span>
  </Link>
</li>
 
                </li>
               
               
                <li className="submenu">
                  <Link
                    to="#"
                    onClick={() => handleItemClick(3)}
                    className={selectedItems[3] ? "subdrop" : ""}
                  >
                    <i className="fe fe-package" />{" "}
                    <span> Regiter Your Business</span>{" "}
                    <span className="menu-arrow" />
                  </Link>
                  <ul style={{ display: selectedItems[3] ? "block" : "none" }}>
                    <li>
                    <Link to="/" className={pathname === "/" ? "active" : ""}>
                        <i className="fe fe-clipboard" />{" "}
                        <span>Add Your Business</span>
                      </Link>
                    </li>
                  </ul>
                </li>
 
              
 
               
                <li className="submenu">
                    <Link
                        to="#"
                        onClick={() => handleItemClick(6)}
                        className={selectedItems[6] ? "subdrop" : ""}
                    >
                        <i className="fe fe-settings" />{" "}
                        <span>System Settings</span>{" "}
                        <span className="menu-arrow" />
                    </Link>
                </li>
               
 
                <li>
                  <Link className={pathname === "/login" ? "active" : ""} to="/login">
                    <i className="fe fe-power" /> <span>Logout</span>
                  </Link>
                </li>
               
                {/* Extras */}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};
export default Sidebar;